import { Button, ButtonLink, Stack } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  isSubmitDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const CreateClientAdminUserFormPresentation: React.FC<Props> = ({
  isSubmitDisabled,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className={styles.form}>
    <Stack direction='column' gap={24}>
      <h2 className={styles.formTitle}>企業管理者の新規追加</h2>
      <div className={styles.formContainer}>
        <Stack direction='column' gap={24}>
          <TextInputFieldController
            name='fullName'
            fieldWrapperProps={{
              labelText: '氏名',
              labelType: 'required',
            }}
            textInput={{
              placeholder: '福利 太郎',
            }}
          />
          <TextInputFieldController
            name='email'
            fieldWrapperProps={{
              labelText: 'メールアドレス',
              labelType: 'required',
            }}
            textInput={{
              type: 'email',
              placeholder: 'fukuri@example.com',
            }}
          />
        </Stack>
      </div>
      <Stack direction='row' gap={8}>
        <ButtonLink to={ROUTES.ADMINS.INDEX} variant='secondary'>
          キャンセル
        </ButtonLink>
        <Button type='submit' disabled={isSubmitDisabled}>
          追加
        </Button>
      </Stack>
    </Stack>
  </form>
);
